import { MyGoalService } from "@/services/myGoalsApi";
import { REQUEST_STATE, STATUS_CODE } from "@/enums";
import { createNamespacedHelpers } from "vuex";
import CurrentSavingsGoalGraph from "@/components/currentSavingsGraph/currentSavingsGraph.vue";
import SetMonthlyGoalModal from "@/components/setMonthlyGoalModal/setMonthlyGoalModal.vue";
import SvgRenderer from "@/components/svgRenderer/svgRenderer.vue";

const { mapActions: userActions, mapGetters: userGetters } = createNamespacedHelpers("user"),
	PERCENT = 100;

export default {
	components: {
		CurrentSavingsGoalGraph,
		SetMonthlyGoalModal,
		SvgRenderer,
	},

	data() {
		return {
			state: REQUEST_STATE.LOADING,
			REQUEST_STATE,
			data: null,
			graphData: null,
			monthlyGoalModalData: null,
		};
	},

	methods: {
		load,
		openSetMonthlyGoalModal,
		closeSetMonthlyGoalModal,

		...userActions(["getMe"]),
	},

	computed: {
		...userGetters(["activeOutlet"]),

		monthlyGoal() {
			return this.activeOutlet.this_month_saving_goal * PERCENT;
		},
	},

	mounted() {
		this.load();
	},
};

function openSetMonthlyGoalModal() {
	this.monthlyGoalModalData = {
		monthlyGoal: this.monthlyGoal,
		baselineWeight: this.data.baseline.total_weight,
	};
}

async function closeSetMonthlyGoalModal(reload) {
	this.monthlyGoalModalData = null;

	if (reload) {
		await this.getMe();
		this.load();
	}
}

// eslint-disable-next-line complexity
async function load() {
	try {
		this.state = REQUEST_STATE.LOADING;

		const { data } = await MyGoalService.getTotalGuestSavings(),
			LAST_MONTHS_COUNT = -4;

		this.data = data;

		this.graphData = {
			baseline: data.baseline,
			months: data.per_month.slice(LAST_MONTHS_COUNT),
		};

		this.state = REQUEST_STATE.SUCCESS;
	} catch (error) {
		if (error.response && error.response.status === STATUS_CODE.MISSING_DATA) this.state = REQUEST_STATE.MISSING_DATA;
	}

	this.$emit("notifyLoaded", this.state);
}
